import { render, staticRenderFns } from "./VelocityAnim.vue?vue&type=template&id=2891334e&"
import script from "./VelocityAnim.vue?vue&type=script&lang=js&"
export * from "./VelocityAnim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports